import { AuthConfig } from '@auth0/auth0-angular';

export const environment = {
  production: true,
  redirectUri: window.location.origin + '/index.html',
  requireHttps: true,
  dashboardLocation: 'https://app.golftechmgt.com',
  api: {
    endpoint: 'https://golftech-prod-appsvc-main-api.azurewebsites.net/api',
    identity: 'https://golftech-prod-appsvc-identity.azurewebsites.net/api'
  },
  signalR: {
    connectionHubUrl: 'https://golftech-prod-appsvc-main-api.azurewebsites.net/connectionHub',
    registrationHubUrl: 'https://golftech-prod-appsvc-main-api.azurewebsites.net/registrationHub',
    bookingHubUrl: 'https://golftech-prod-appsvc-main-api.azurewebsites.net/bookingHub',
    bookingCreateListener: 'BroadcastBookingCreate',
    bookingUpdateListener: 'BroadcastBookingUpdate',
    registrationUpdateListener: 'BroadcastRegistrationUpdate',
    registrationPaymentListener: 'BroadcastRegistrationPayment',
    registrationPaymnetErrorListener: 'BroadcastRegistrationPaymentError',
    scheduledBookingUpdateListener: 'BroadcastScheduledBookingCreate',
    scheduledBookingCreateListener: 'BroadcastScheduledBookingCreate',
    scheduledBookingPaymentUpdateListener: 'BroadcastScheduledBookingPaymentUpdate',
  },
  stripe:{
    token: 'pk_live_51Mf6NPALH8bDoJHvdsVi9FBNE404Ck58A7zjYC5hGAzOM1SRivyVV9EG97F4jQSx2zldbQU0QFummcRHWWGfnRhL00LIJpZwPu',
    returnUrl: 'https://golftech-prod-appsvc-ui.azurewebsites.net/my-account',
    internalProductId: 'prod_QGSCJxvBxDWejH',
    applicationFee: .03,
    outingPlatformFreeProductId: 'prod_QGSBU419kK92Gl',
    tierExemptAccounts: ['acct_1QuLqmPQ44744jRU']
  },
  auth0: {
    domain: 'golftechmgt.us.auth0.com',
    clientId: 'hUxqChWcdicPz472aJh6DMc7GK48Wtrp',
    authorizationParams: {
      redirect_uri: window.location.origin + '/callback',
      audience: 'https://logical-prod/api'
    },
    cacheLocation: 'localstorage',
    useRefreshTokens: true,
    httpInterceptor: {
      allowedList: [
        'https://golftech-prod-appsvc-main-api.azurewebsites.net/api/*', 
        'https://golftech-prod-appsvc-identity.azurewebsites.net/api/*',
        {
          uri: 'https://golftech-prod-appsvc-api.azurewebsites.net/api/booking-widget/*',
          allowAnonymous: true,
        },
        {
          uri: 'https://golftech-prod-appsvc-api.azurewebsites.net/api/digital-waiver-widget/*',
          allowAnonymous: true,
        }]
    }
  } satisfies AuthConfig,
  auth0LogicalApi: {
    client_id: 'znJOiUdJlLop7EXLCgViqinMArlC59xY',
    client_secret: 'OsJabVsZxMvJBB5ftzxbEEGOxgD2zsyrg5AdFjBqbtsCAM3vHsRDIfiiONoY9WQF',
    audience: 'https://logical-prod/api',
    grant_type: 'client_credentials'
  },
  syncfusion: "ORg4AjUWIQA/Gnt2XFhhQlJHfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH5WdEJiXH5cdXJXTmJVWkZ/"
};